import {
  Component,
  ChangeDetectionStrategy,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Tabs, AppLogger } from 'app-core';

@Component({
  selector: 'app-dummy-data-doctors-home',
  templateUrl: './dummy-data-doctors.component.html',
  styleUrls: ['./dummy-data-doctors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyDataDoctorsHomeComponent {
  @ViewChild('usersTemplate', { static: true })
  public usersTemplate!: TemplateRef<any>;
  @ViewChild('doctorsTemplate', { static: true })
  public doctorsTemplate!: TemplateRef<any>;
  @ViewChild('appointmentsTemplate', { static: true })
  public appointmentsTemplate!: TemplateRef<any>;
  @ViewChild('couponsTemplate', { static: true })
  public couponsTemplate!: TemplateRef<any>;
  @ViewChild('medicinesTemplate', { static: true })
  public medicinesTemplate!: TemplateRef<any>;
  public tabLoaded: boolean[] = [false, false];
  public selectedItemIndex = 0;
  public items: Array<Tabs> = [];

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _route: Router,
  ) {}

  public ngOnInit(): void {
    const route = this._route.url.split('/');
    if (
      route.some((item) => item === 'users') &&
      route.some((item) => item === 'doctors')
    ) {
      this.selectedItemIndex = 0;
    } else if (route.some((item) => item === 'appointments')) {
      this.selectedItemIndex = 2;
    } else if (route.some((item) => item === 'coupons')) {
      this.selectedItemIndex = 3;
    } else if (route.some((item) => item === 'medicines')) {
      this.selectedItemIndex = 4;
    } else {
      this.selectedItemIndex = 1;
    }

    this.items = [
      {
        label: 'Users',
        content: this.usersTemplate,
        index: 0,
        routeLink: `manage/dummy-data/doctors/users`,
      },
      {
        label: 'Doctors',
        content: this.doctorsTemplate,
        index: 1,
        routeLink: `manage/dummy-data/doctors/doctors`,
      },
      {
        label: 'Appointments',
        content: this.appointmentsTemplate,
        index: 2,
        routeLink: `manage/dummy-data/doctors/appointments`,
      },
      {
        label: 'Coupons',
        content: this.couponsTemplate,
        index: 3,
        routeLink: `manage/dummy-data/doctors/coupons`,
      },
      {
        label: 'Medicines',
        content: this.medicinesTemplate,
        index: 4,
        routeLink: `manage/dummy-data/doctors/medicines`,
      },
    ];

    this._cdRef?.markForCheck();
  }

  public tabChange(selectedItem: MatTabChangeEvent): void {
    this.selectedItemIndex = this.items.findIndex(
      (item) => item.index === selectedItem.index,
    );
    if (!this.tabLoaded[this.selectedItemIndex]) {
      this.tabLoaded[this.selectedItemIndex] = true;
    }
    // Get the current URL without query params
    const newUrl = `${this.items[this.selectedItemIndex].routeLink}`;
    this._route
      .navigate([newUrl], { queryParamsHandling: 'preserve' })
      .catch((err: string | Error) => AppLogger.Error(err));
  }
}
